var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item && (_vm.item.url_youtube))?_c('iframe',{attrs:{"id":"ancora-youtube","type":"text/html","width":"370","height":"210","src":_vm.urlYoutube,"frameborder":"0"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }